import { Component, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaseDetailsModel } from '@app/core/models/case.model';
import { CaseActions, CaseSelectors } from '@app/store';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import EventEmitter from 'events';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-case-detail-dialog',
  templateUrl: './case-detail-dialog.component.html',
  styleUrls: ['./case-detail-dialog.component.scss'],
})
export class CaseDetailDialogComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  caseDetails: CaseDetailsModel = null;
  caseDetailsError = null;
  loading: boolean = false;

  @Output() expandedElementEvent = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    if (this.data.caseNumber) {
      this.loading = true;
      this.store.dispatch(
        CaseActions.getCaseDetails({ caseNumber: this.data.caseNumber })
      );

      this.subscriptions.add(
        this.store
          .select(CaseSelectors.getCaseDetailsMap)
          .subscribe(caseDetails => {
            if (caseDetails && Object.keys(caseDetails).length > 0) {
              this.caseDetails = caseDetails[this.data.caseNumber];
              this.loading = false;
            }
          })
      );

      this.subscriptions.add(
        this.store
          .select(CaseSelectors.getCaseDetailsError)
          .subscribe(error => {
            if (error) {
              this.loading = false;
              this.caseDetailsError = error;
            }
          })
      );
    }
  }

  setExpandedElement(element: any | null) {
    this.expandedElementEvent.emit(element);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
